<template>
  <div class="newreport">
     <z-fix-top
      ref="fixtop"
      v-if="!showFixTop"
      keep-position
      class="fixtop"
      :style="{background: '#F7F7F7'}"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          :title="navTitle"
          @click-left="handleClickLeft"
      >
      </z-nav-bar>
    </z-fix-top>
    <div class="childContainer" :style="{ height: childHeight + 'px' }">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { NavBar, FixTop, Dialog, Toast } from '@zz-common/zz-ui';
import { queryParams, getCookie } from '../../lib/utils'
import { newReportGetReason, newReportSubmit } from '@api/resourceApi'

const query = queryParams()
console.log('打印举报参数', query)

export default {
  name: 'ReportReason',
  data() {
    return {
      sharedData: {
        from: query.from || this.$route.query.from, // 举报来源1商品页 2用户页 3私信页 4私信页策略举报链接 5视频 6图片 7短视频 8url 9帖子 10补充举报(补充举报已经废弃，现在按成普通举报处理) 11直播 12放心转
        toUid: query.bereporteduid || this.$route.query.bereporteduid, //用户uid
        infoId: query.infoid || this.$route.query.infoid, //信息uid
        postId: query.postId || this.$route.query.postId, //帖子uid
        videoId: query.videoId || this.$route.query.videoId, //视频uid
        appType: getCookie('t'), //15 转转安卓，16 转转ios, 20 转转鸿蒙
        reasonList: [], //原因列表
        firstReason: {}, //一级原因
        globalLoading: false, //全局提交loading
        evidenceLoading: false // 凭证上传loading。上传完成前禁止提交
      },
      navTitle: '',
      childHeight: 0
    }
  },
  components: {
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar
  },
  computed: {
    showFixTop() {
      return this.$route.name == 'choosereason' || this.$route.name == 'phonesubmit'
    }
  },
  watch: {
    showFixTop(val) {
      if (!val) {
        //本来不用动态计算高度，但是childContainer的样式高度在低版本手机上获取不到，导致子元素height：100%不生效
        this.$nextTick(() => {
          console.log(window.innerHeight - this.$refs.fixtop.$el.clientHeight)
          this.childHeight = window.innerHeight - this.$refs.fixtop.$el.clientHeight
        })
      }
    }
  },
  //全局信息和方法
  provide() {
    return {
      sharedData: this.sharedData, //共享数据
      setNavTitle: this.setNavTitle, //设置导航栏标题
      setFirstReason: this.setFirstReason, //设置一级原因
      globalSubmit: this.globalSubmit, //全局提交方法
      toggleEvidenceLoading: this.toggleEvidenceLoading //全局凭证上传loading
    }
  },
  methods: {
    //加载原因
    loadReasonList() {
      return new Promise((resolve) => {
        newReportGetReason().then((data) => {
          console.log('fetch reason list success', data)
          const transfer = [
            data.slice(0, 4),
            [data[4]],
            [data[5]]
          ]
          resolve(transfer)
        })
      })
    },
    setNavTitle(val) {
      this.navTitle = val
    },
    handleClickLeft() {
      if (this.showFixTop) {
        native.close()
      } else {
        this.$router.back()
      }
    },
    setFirstReason(val) {
      this.sharedData.firstReason = val
    },
    globalSubmit(data, clear = false) {
      console.log('看看最终提交数据', {
        ...data,
        reqUid: getCookie('uid'),
        toUid: this.sharedData.toUid,
        appType: this.sharedData.appType,
        reportTypeId: this.sharedData.firstReason.id,
        reportTypeDesc: this.sharedData.firstReason.type
      })
      this.sharedData.globalLoading = true
      newReportSubmit({
        ...data,
        reqUid: getCookie('uid'),
        toUid: this.sharedData.toUid,
        appType: this.sharedData.appType,
        reportTypeId: this.sharedData.firstReason.id,
        reportTypeDesc: this.sharedData.firstReason.type,
        infoId: this.sharedData.infoId,
        reportSource: this.sharedData.from
      }).then(res => {
        if (clear) {
          localStorage.removeItem('phonesubmit')
        }
        console.log(res)
        this.sharedData.globalLoading = false
        // 根据 respCode 处理不同的返回情况
        const { respCode, respData, errMsg } = res
        // respCode = 0: 正常，返回 id，跳转详情页
        if (+respCode === 0) {
          const reportId = typeof respData === 'string' ? respData : (respData && respData.id ? respData.id : respData)
          this.$toast('提交成功')
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html?needHideHead=3#/newReportDetial?id=${reportId}&toUid=${this.sharedData.toUid}`,
            needClose: '1'
          })
        } else if (+respCode === -1) {
          // respCode = -1: 拦截，解析 JSON 渲染弹窗
          let interceptData = null
          if (typeof respData === 'string') {
            try {
              interceptData = JSON.parse(respData)
            } catch (e) {
              console.error('解析 respData 失败:', e)
            }
          } else if (respData && typeof respData === 'object') {
            interceptData = respData
          }
          // 如果包含拦截信息（retButtons），显示弹窗
          if (interceptData && interceptData.retButtons && Array.isArray(interceptData.retButtons)) {
            const { retButtons = [], punishDesc = '', punishTitle = '提示' } = interceptData
            let confirm = {}
            let cancel = {}
            const dialogParams = {
              title: punishTitle,
              message: punishDesc,
              closeOnClickOverlay: false
            }
            const buttonLength = retButtons.length
            // 单按钮逻辑
            if (buttonLength === 1) {
              confirm = retButtons[0]
              dialogParams.confirmButtonText = retButtons[0].buttonDesc
            }
            // 双按钮逻辑：type=2 是取消，type=1 是确认
            if (buttonLength === 2) {
              retButtons.forEach((btn) => {
                if (btn.type === '2') {
                  cancel = btn
                  dialogParams.showCancelButton = true
                  dialogParams.cancelButtonText = btn.buttonDesc
                } else {
                  confirm = btn
                  dialogParams.confirmButtonText = btn.buttonDesc
                }
              })
            }
            Dialog(dialogParams)
              .then(() => {
                // 确认按钮点击
                if (confirm.type === '0') {
                  native.close()
                } else if (confirm.type === '1' && confirm.mUrl) {
                  native.skipToUrl({
                    targetUrl: confirm.mUrl,
                    needClose: '0'
                  })
                }
              })
              .catch(() => {
                // 取消按钮点击
                if (cancel.type === '0') {
                  native.close()
                } else if (cancel.type === '1' && cancel.mUrl) {
                  native.skipToUrl({
                    targetUrl: cancel.mUrl,
                    needClose: '0'
                  })
                } else if (cancel.type === '2') {
                  native.close()
                }
              })
          } else {
            // 不包含拦截信息，按照原来的逻辑：进入 catch
            const errorMsg = errMsg || '网络异常，请稍后重试'
            Toast.fail(errorMsg)
            throw new Error(respData || errorMsg)
          }
        } else {
          // 其他 respCode（包括 respCode = 1）: 保持原来的逻辑，进入 catch
          const errorMsg = errMsg || '网络异常，请稍后重试'
          Toast.fail(errorMsg)
          throw new Error(respData || errorMsg)
        }
      })
        .catch(err => {
          this.sharedData.globalLoading = false
          const errMsg = typeof err === 'string' ? err : (err?.errMsg || err?.msg || '提交失败，请稍后重试')
          this.$toast(errMsg)
        })
    },
    toggleEvidenceLoading(val) {
      this.sharedData.evidenceLoading = val
    }
  },
  created() {
    this.loadReasonList().then(res => {
      this.sharedData.reasonList = res
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
